import { useState } from 'react';

interface UseChatHandleKeyDownProps {
  sendMessage: () => void;
  isMobile: boolean;
}

export const useChatHandleKeyDown = ({ sendMessage, isMobile }: UseChatHandleKeyDownProps) => {
  const [isComposing, setIsComposing] = useState(false); // IME 입력 상태

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      if (isComposing) return; // IME 입력 중이면 무시
      if (isMobile || e.shiftKey) {
        // 모바일이거나 Shift+Enter 입력 시 줄바꿈 허용
        return;
      }
      e.preventDefault(); // 기본 엔터 동작 방지
      sendMessage();
    }
  };

  const handleCompositionStart = () => setIsComposing(true);
  const handleCompositionEnd = () => setIsComposing(false);

  return {
    handleKeyDown,
    handleCompositionStart,
    handleCompositionEnd,
  };
};
